/* eslint-disable react/prop-types */
import React from 'react';
import {SafeAreaView, View} from 'react-native';
import {responsiveWidth} from '../../components/customResponsiveDimension';
// import styles from '../../styles/individualAddRecipientStyle';
// import { hocComponent } from '../../components';
import CustomText from '../../components/customText';
// api import
import {getAllNotifications} from '../../network/request/notification/viewAllNotification';
import {CUST_ID, getPrefData, INSTID} from '../../storage/preferenceStorage';
import TouchableOpacity from '../../components/customTouchableOpacity';

const dummy = {
  result: ['Funding account validation pending! Validate now.!', 'Funding account validation expired! Re-register account now.', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721855 ', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721917 ', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721887 ', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721854 ', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721859 ', 'Your money transfer is not funded yet! Fund your transfer now for M2X10721858 '],
  status: 'success'
};
class NotificationModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {resData: []};
  }

  componentWillMount() {
    this.getNotifications();
  }

  getNotifications = async () => {
    const {makeAPICall} = this.props;

    const custId = await getPrefData(CUST_ID);
    const instId = await getPrefData(INSTID);
    makeAPICall(getAllNotifications(instId, custId), this.onDataReceived, this.onError);
  };

  onDataReceived = response => {
    let data;
    const arrayData = [];
    const count = response.result.length;
    let countValue;
    if (count === 1) {
      countValue = 1;
    } else if (count === 2) {
      countValue = 2;
    } else if (count === 3) {
      countValue = 3;
    } else if (count === 4) {
      countValue = 4;
    } else {
      countValue = 5;
    }
    for (let i = 0; i < countValue; i++) {
      data = {result: response.result[i]};
      arrayData.push(data);
    }
    if (response.result.length !== 0) {
      this.setState({
        resData: arrayData // real time--- >    resData: response.result,
      });
    }
  };

  onError = error => {};

  render() {
    const {navigation, measure} = this.props;
    const {resData} = this.state;

    const renderData = resData.map(item => {
      return (
        <View
          style={{
            paddingVertical: '4%',
            paddingHorizontal: '4%',
            backgroundColor: '#FCF2EC',
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderColor: '#e7e7e7',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          {/* change to 80% if using the time also */}
          <View style={{width: '90%'}}>
            <CustomText style={{fontSize: 14, lineHeight: 20, color: '#4A4A4A'}}>{item.result}</CustomText>
          </View>
        </View>
      );
    });

    return (
      <SafeAreaView style={{flex: 1}}>
        <View
          style={{
            // backgroundColor: 'blue',
            flexDirection: 'column',
            width: measure === 'MDPI' || measure === 'LDPI' ? responsiveWidth(95) : '100%'
          }}>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              height: 60,
              backgroundColor: '#FCFCFC',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <View
              style={{
                width: '70%',
                marginLeft: 20
              }}>
              <CustomText>Notifications</CustomText>
            </View>
            <View style={{width: '20%'}}>
              <TouchableOpacity style={{padding: 5}} onPress={() => navigation.navigate('AllNotificationsPage')}>
                <CustomText style={{color: '#e77817'}}>View All</CustomText>
              </TouchableOpacity>
            </View>
          </View>
          <View>{renderData}</View>
        </View>
      </SafeAreaView>
    );
  }
}
export default NotificationModel;
